import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@project-mgmt/feature-auth";
import { PageLoadingSpinner } from "./LoadingSpinner";
import { PageErrorBoundary } from "./ErrorBoundary";
import { OfflineIndicator } from "./OfflineIndicator";

/**
 * ProtectedLayout component that wraps protected routes
 * - Checks authentication status
 * - Shows loading spinner while checking auth
 * - Redirects to /login if not authenticated
 * - Renders Outlet for authenticated users
 *
 * Note: This component provides the authentication guard.
 * The actual layout UI (navigation, header, etc.) will be handled by the existing
 * Layout component structure when integrated with React Router.
 */
export function ProtectedLayout() {
  const { user, isLoading } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return <PageLoadingSpinner message="Checking authentication..." />;
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Render nested routes for authenticated users
  return (
    <PageErrorBoundary>
      <OfflineIndicator />
      <Outlet />
    </PageErrorBoundary>
  );
}
